/** Maximum age of a client-supplied `completedAt` accepted for calendar attribution. */
export const SESSION_COMPLETE_MAX_COMPLETED_AT_AGE_DAYS = 30;

/** Future skew tolerance for client clocks before clamping to server time. */
export const SESSION_COMPLETE_MAX_FUTURE_SKEW_MS = 5 * 60 * 1000;

/** Path-safe client request id: alphanumeric, hyphen, underscore; 8–128 chars. */
export const CLIENT_REQUEST_ID_PATTERN = /^[A-Za-z0-9_-]{8,128}$/;
